module.exports = __webpack_public_path__ + "img/sshyzx.0de1e1e2.png";